import { render, staticRenderFns } from "./ProfileTechnician.vue?vue&type=template&id=72260b70&scoped=true"
import script from "./ProfileTechnician.vue?vue&type=script&lang=js"
export * from "./ProfileTechnician.vue?vue&type=script&lang=js"
import style0 from "./ProfileTechnician.vue?vue&type=style&index=0&id=72260b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72260b70",
  null
  
)

export default component.exports